import styled from 'styled-components';
import Loader from 'react-loader-spinner';
import { fontDisplay } from '../theme/typography';

export const StyledLoader = styled(Loader)`
  position: fixed;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
`;
export const StyledContainerLoader = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  z-index: 10;
  background: ${({ theme }) => theme.page};
`;
export const StyledWrapper = styled.main`
  position: relative;
  width: 100%;
  margin: 0 auto;
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  min-height: calc(100vh - 35px);
  padding-top: 8px;
  > h1 {
    ${fontDisplay};
    font-size: 28px;
    line-height: 1.15;
    letter-spacing: -0.02em;
    width: 100%;
    text-transform: none;
    margin-bottom: 24px;
    @media (min-width: 48em) {
      margin: 0 25px;
      margin-bottom: 24px;
    }
  }
  @media only screen and (max-width: 1199px) {
    padding-left: 0;
    padding-right: 0;
    width: 100%;
  }
  @media screen and (min-width: 1200px) {
    padding-top: 14px;
  }
  @media (min-width: 1440px) {
    max-width: 1640px;
    width: 100%;
  }
`;
